export default "__VITE_ASSET__CngZdYkw__"